class shareBarCopyLink {
    constructor(el) {
        this.scope = el;
        this.bindEvents();
    }

    bindEvents() {
        this.scope.addEventListener('click', (evt) => {
            evt.preventDefault();
            const url = window.location.href;

            if (navigator.clipboard) {
                navigator.clipboard.writeText(url);
            }
        });
    }
}

document.querySelectorAll('[data-share-copy]').forEach(elm => new shareBarCopyLink(elm));